import PatientEnrollment from './PatientEnrollment';

export default PatientEnrollment;



// WEBPACK FOOTER //
// ./src/views/pages/PatientEnrollment/index.js